export const agencySelectionText = {
  oneAgencyPerMember:
    'Only one free agency is allowed for a user. You have selected more than one. Are you sure you want to proceed?',
  registrationHeader:
    "A great way to find out about new opportunities on OpenBids is to subscribe to a government agency. To get started, please choose your first (free!) agency. You'll have a chance to sign up for more in just a moment.",
  selectedAgencyLabel: 'Selected free agency:',
  standardHeader:
    'Free offer! Receive notifications whenever an agency of your choice posts new bid opportunities on OpenBids. To get started, please choose an agency you’d like to subscribe to. You’ll have a chance to sign up for more in just a moment.',
} as const;
